import Headline from '@common/components/headline/Headline';
import { Seo } from '@common/components/SEO/SEO';
import { getCountryCode, getLanguage } from '@common/utils/lang';
import { useLazyFetchPageQuery } from '@features/cdn/cdnApi';
import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import SourceResult from './components/SourceResult';

const Source = () => {
  const lang = getLanguage();
  const countryCode = getCountryCode().toLowerCase();
  const [ fetchPage, { data } ] = useLazyFetchPageQuery();

  useEffect(() => {
    const page = 'sources';
    const pageName = page.concat(`_${countryCode}.json`);
    fetchPage({ lang, pageName });
  }, [ countryCode, lang, fetchPage ]);

  return (
    <Box>
      <Seo
        title="Источники"
        description="Источники"
      />

      <Headline disableBackground title={<FormattedMessage id="SOURCES_PAGE"/>}/>

      {data && <SourceResult pageData={data}/>}
    </Box>
  );
};

export default Source;
